var _style, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEtcusdt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ETC",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3AB83A;}\n\t.st1{fill:#0B8311;}\n\t.st2{fill:#146714;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1599",
    className: "st0",
    d: "M95.7,272.3c54.4,28.9,111.1,59.1,155,82.5l153.7-82.5C348.7,355,302.3,423.8,250.6,500 C198.9,424,141.7,340.1,95.7,272.3z M101.6,249.5l149.2-79.6l147.3,79.1l-147.2,79.7L101.6,249.5z M250.6,144.3l-155,81.6L250,0 l154.4,226.4L250.6,144.3L250.6,144.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1593",
    className: "st1",
    d: "M250.6,354.8l153.7-82.5C348.7,355,250.6,500,250.6,500V354.8z M250.8,169.8l147.3,79.1 l-147.2,79.7L250.8,169.8L250.8,169.8z M250.6,144.3L250,0l154.4,226.4L250.6,144.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path1603",
    className: "st1",
    d: "M101.6,249.5l149.2,12.2L398.1,249l-147.2,79.7L101.6,249.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path1606",
    className: "st2",
    d: "M250.8,261.7L398.1,249l-147.2,79.7L250.8,261.7L250.8,261.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtcusdt);
export default __webpack_public_path__ + "static/media/etcusdt.6e19630b11b61188ff8e3a13fa38c265.svg";
export { ForwardRef as ReactComponent };